import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import tabsGroup from "../../config/TabsGroup";
import { Average, Target } from "../../store/Session/SessionModel";
import { getCombineKeyDataQuality } from "../../store/Session/helper/combineTargetQualityDisplay";
import { normalizedKeys } from "../../config/NormalizedValues";
import { RootState } from "../../store/store";
import { LmLocation } from "../../models";

import { useEffect, useState } from "react";
import { shotQualityRanges } from "../../config/CombineTutorial";
import "./style.css";

interface Props {
	tabSelected: "ball-data" | "club-data" | "key-data";
	target: Target;
}

// KWSA-24: In Simulator mode normalized values render white (no blue highlight), matching the Golf app.
const normalizedClass = (target: Target, key: string, isSimulator: boolean) => {
	return normalizedKeys.includes(key) && target.isNormalized && !isSimulator
		? "normalized"
		: "";
};

const qualityKey = (value: any) => {
	const strQuantity = shotQualityRanges(value)?.quality;
	return strQuantity === "none" ? "none number" : strQuantity;
};

const TargetTiles = ({ tabSelected, target }: Props): JSX.Element => {
	const [group, setGroup] = useState(tabsGroup[tabSelected]);
	const keyDataQuality = getCombineKeyDataQuality(target);
	const location = useSelector((state: RootState) => state.session.location);
	const isSimulator = location === LmLocation.SIMULATOR;

	useEffect(() => {
		setGroup([...tabsGroup[tabSelected]]);
		if (!target.targetId && target.totalShots > 0) {
			const newTabItems = tabsGroup[tabSelected]?.filter((item: any) => {
				const keysIgnore = ["quality", "distanceToPin"];
				return !keysIgnore.includes(item.avgKey);
			});
			setGroup([...newTabItems]);
		}
	}, [target, tabSelected]);
	if (!group) {
		return <></>;
	}
	return (
		<div className="tiles">
			{group?.map((tabItems: any) => (
				<div className="data-card-small" key={tabItems.avgKey}>
					<div className="data-label">
						{target.average[tabItems.avgKey as keyof Average].label}
					</div>
					{tabItems.avgKey === "quality" ? (
						<>
							<div className={`tile-quality combine-item`}>
								<div
									className={`combine-item-score ${qualityKey(keyDataQuality.rangeValue)}`}>
									{keyDataQuality.display}
								</div>
							</div>
						</>
					) : (
						<>
							<div
								className={`number ${normalizedClass(target, tabItems.avgKey, isSimulator)}`}>
								{target.average[tabItems.avgKey as keyof Average].value}
							</div>
							<div className="uom">
								{target.average[tabItems.avgKey as keyof Average].uom}
							</div>
						</>
					)}
				</div>
			))}
		</div>
	);
};

TargetTiles.propTypes = {
	tabSelected: PropTypes.oneOf(["ball-data", "club-data", "key-data"]),
};

export default TargetTiles;
